import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import useStateRef from "react-usestateref";
import { DEFAULT_IMAGE_140 } from "../../middleware/types";


const ProductTitile = (props) => {



	function replaceGridViewImage(event) {
		event.target.src = DEFAULT_IMAGE_140;
	}
	return (
		<div className={`col-6 col-md-3`}>
			<div class="c-feature-product qv-model">
				<Link to={props.value["productUrl"]} class="c-product-link">
					<img onError={replaceGridViewImage} alt="Insect Display Case" src={props.value["product.smallImageUrl"] ? props.domainName.concat(props.value["product.smallImageUrl"]) : ""} class="c-product-img" />
					<h3 class="os-product-title" dangerouslySetInnerHTML={{__html : props.value["product.productName"] ? props.value["product.productName"] : ""}}>
					</h3>
				</Link>
			</div>
		</div>
	)
}

export default ProductTitile